import { injectTokens } from "@saviynt/tokens";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import "@saviynt/design-system/dist/module.css";
import "./style.css";

// Signal to MFEs that they are running inside the ispm host.
// Must run before the first render so MFE hooks see it on their initial pass.
(window as Window & { __MFE_HOST__?: string }).__MFE_HOST__ = "ispm";

// Provide the API base URL for federated remotes.
// Remotes check window.__MFE_API_BASE_URL__ before falling back to their own logic.
// In dev, use /api-proxy (Vite proxy). In prod, use the configured API URL or same origin.
(window as Window & { __MFE_API_BASE_URL__?: string }).__MFE_API_BASE_URL__ =
  import.meta.env.DEV
    ? "/api-proxy"
    : (import.meta.env.VITE_API_BASE_URL as string) || window.location.origin;

// One-time cleanup: remove legacy access_token cookie for users who had
// it set before the migration to localStorage-only auth.
document.cookie =
  "access_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";

// Inject Saviynt tokens on app load
injectTokens();

createRoot(document.getElementById("app")!).render(<App />);
